module.exports = __webpack_public_path__ + "static/teacher-guide-865b81c3ccf8279cc37056f8c680636b.pdf";